var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-progress-circular',{staticClass:"mr-3",attrs:{"indeterminate":"","size":"16","width":"2"}}),_vm._v(" Loading Audio … ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }